import { GripHorizontalIcon } from "assets/svg";
import styled from "styled-components";

import { Tooltip } from "uikit";

export const Container = styled.div`
  position: fixed;
  z-index: 200;
  width: 400px;
  height: 82vh;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  box-shadow: 0px 10px 24px 0px ${({ theme }) => theme.colors.colorsNew.base.black}15;
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

export const IconContainer = styled.div``;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  padding: 14px 16px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  ${IconContainer} {
    cursor: pointer;
  }
`;

export const GripHorizontalIconStyled = styled(GripHorizontalIcon)`
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`;

export const StyledTooltip = styled(Tooltip)`
  .__react_component_tooltip {
    width: max-content;
  }
`;

export const Content = styled.div`
  padding: 16px;
  height: 100%;
  overflow: hidden;
  display: flex;
`;

export const Footer = styled.div``;
